import { render, staticRenderFns } from "./OrderPrintWrapper.vue?vue&type=template&id=d961cdce&"
import script from "./OrderPrintWrapper.vue?vue&type=script&lang=js&"
export * from "./OrderPrintWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports